import React from "react";
import { useTranslation } from "react-i18next";

export default function TotalPrize() {
    const { t } = useTranslation();
    const PrizeData = t("prize", { returnObjects: true });

    const generateSuperlatives = (number) => {
        if (number === 1) {
            return "st";
        } else if (number === 2) {
            return "nd";
        } else if (number === 3) {
            return "rd";
        } else {
            return "th";
        }
    }

    return (
        <>
            <div id="prizes-section" className="w-full bg-prizeMobile md:bg-prize relative bg-bottom bg-cover bg-no-repeat min-h-[125vh] flex max-md:flex-wrap items-center">
                <div className="container mx-auto font-poppins text-white">
                    <div className="hidden md:block text-center md:text-left relative md:left-24">
                        <p className="text-8xl md:text-9xl text-brandYellow font-superWonder">{t("home.prize.title")}</p>
                        <p className="text-2xl text-white px-3 py-1 bg-brandBlue rounded-lg w-fit font-bold relative -right-36" style={{ letterSpacing: '3px' }}>{t("home.prize.subTitle")}</p>
                    </div>
                    <div className="flex items-center justify-center mt-12">
                        <div className="grid grid-cols-2 md:flex md:flex-row gap-x-4 md:gap-x-16 justify-center items-top md:items-center mx-4 md:mx-16 max-md:gap-y-4">
                            <div className="block md:hidden text-center md:text-left relative md:left-24 top-24">
                                <p className="text-6xl text-brandYellow font-superWonder">{t("home.prize.title")}</p>
                                <p className="text-xs text-white px-3 py-1 w-fit font-bold relative left-6" style={{ letterSpacing: '3px' }}>{t("home.prize.subTitle")}</p>
                            </div>
                            {PrizeData?.map((value, index) => (
                                <div className={`basis-full flex justify-center flex-wrap bg-white rounded-3xl max-w-[240px]`} key={index}>
                                    <div className="text-center bg-brandYellow rounded-t-3xl py-2">
                                        <p className="text-base text-brandBlue font-bold px-4 lg:px-8 py-2 uppercase md:min-h-[48px]">{value.category}</p>
                                    </div>
                                    <div className="py-2 md:py-6 md:px-4 text-center rounded-b-lg font-normal font-poppins text-brandBlue text-xs min-h-[272px]">
                                        {value.data.map((item, index) => (
                                            <div key={index}>
                                                <span className="font-black text-xl">{item.id}</span>
                                                <span className="align-top text-sm font-black">{generateSuperlatives(item.id)}</span>
                                                <span className="text-xl text-brandGrey font-medium">&nbsp;{new Intl.NumberFormat("en-US", { style: "decimal", currency: "IDR" }).format(item.prize)}</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
